<div
  class="zipcode-banner"
  *ngIf="isGuestUser"
  [ngClass]="{ tablet: isTablet }"
>
  <div class="zipcode-text-container" *ngIf="!isMobile">
    <span
      class="title"
      [innerHTML]="'i18n.search.browsePage.zipCodeBanner.title' | translate"
    ></span>
    <span
      class="subtitle"
      [innerHTML]="'i18n.search.browsePage.zipCodeBanner.text' | translate"
    ></span>
  </div>
  <div class="zipcode-input-container" [ngClass]="{ mobile: isMobile }">
    <div class="zipcode-selector-container">
      <div class="zipcode-selector">
        <span>{{
          'i18n.search.browsePage.zipCodeBanner.label' | translate
        }}</span>
        <ion-item>
          <ion-input
            placeholder="Zip Code"
            #input
            [(ngModel)]="zipCodeValue"
            [maxlength]="zipCodeLength"
            type="number"
            pattern="[0-9]*|Enter"
            (keyup)="keyUpZipCodeValidation($event)"
            (keydown)="keyDownValidation($event)"
            (ionInput)="ionInputZipCodeValidation($event)"
            (paste)="pasteZipCodeValidation($event)"
            (keydown.enter)="switchGuestZip($event)"
          ></ion-input>
        </ion-item>
      </div>
    </div>
  </div>
</div>
